import { App } from '@capacitor/app';
import { PushNotifications } from '@capacitor/push-notifications';
import { LocalNotifications } from "@capacitor/local-notifications";

const LAST_ACTIVE_KEY = 'last_active_timestamp';

const automaticLogoutMixin = {
	created() {
		let lastActiveTimestamp = localStorage.getItem(LAST_ACTIVE_KEY);
		this.$store.commit('SET_LAST_ACTIVE_TIMESTAMP', lastActiveTimestamp);
	},

	mounted() {
		if (!this.$store.state.app.native) {
			return;
		}

		App.addListener('pause', () => {
			this.handleAppHidden();
		});

		App.addListener('appStateChange', ({ isActive }) => {
			if (!isActive) {
				this.handleAppHidden();
				return;
			}

			this.handleAppVisible('appStateChange');
		});
	},

	methods: {
		handleAppHidden() {
			let lastActiveTimestamp = +new Date();
			this.$store.commit('SET_LAST_ACTIVE_TIMESTAMP', lastActiveTimestamp);
			localStorage.setItem(LAST_ACTIVE_KEY, lastActiveTimestamp);
		},

		handleAppVisible(trigger) {
			let lastActiveTimestamp = localStorage.getItem(LAST_ACTIVE_KEY);
			if (!lastActiveTimestamp) {
				return false;
			}

			this.$store.dispatch('checkAutomaticLogoutStatus', trigger);

			localStorage.removeItem(LAST_ACTIVE_KEY);
			this.$store.commit('SET_LAST_ACTIVE_TIMESTAMP', 0);
		},
	},

	destroyed() {
		if (this.$store.state.app.native) {
			App.removeAllListeners();
		}
	},
};

export default automaticLogoutMixin;
